<template>
  <div v-frag>
    <CardIeaAppMain colorCard="#A7BA38">
      <v-col cols="12" sm="12" xs="12" md="12" lg="12" xl="12">
        <v-expansion-panels flat>
          <v-expansion-panel>
            <v-expansion-panel-header
              ><h2>Test Equivalencia</h2></v-expansion-panel-header
            >
            <v-expansion-panel-content>
              <v-sheet class="black--text">Descripcion del Test</v-sheet>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>

        <div v-if="verRealizoSecundario">
          <v-card elevation="11" outlined shaped>
            <v-card-title class="d-flex justify-left pl-16"
              >1)¿ Hizó algo del secundario ?
            </v-card-title>
            <v-card-text class="pl-12">
              <v-container fluid>
                <v-col cols="12" sm="6" md="6">
                  <v-radio-group v-model="realizoSecundario">
                    <v-radio label="si" value="true" color="red"></v-radio>
                    <v-radio label="no" value="false" color="red"></v-radio>
                  </v-radio-group>
                </v-col>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <div class="pl-16 mb-10" v-if="realizoSecundario == 'true'">
                <v-btn
                  color="primary"
                  elevation="7"
                  large
                  @click="funcionRealizoSecundario()"
                  >Siguiente</v-btn
                >
              </div>
              <div class="pl-16 mb-10" v-if="realizoSecundario == 'false'">
                <v-btn
                  color="primary"
                  elevation="7"
                  large
                  @click="functionFinalizar()"
                  >Finalizar</v-btn
                >
              </div>
            </v-card-actions>
          </v-card>
        </div>

        <div v-if="verColegioTecnico">
          <v-card elevation="11" outlined shaped>
            <v-card-title class="d-flex justify-left pl-16"
              >2)¿ Erá colegio técnico ?
            </v-card-title>
            <v-card-text class="pl-12">
              <v-container fluid>
                <v-col cols="12" sm="6" md="6">
                  <v-radio-group v-model="colegioTecnico">
                    <v-radio label="si" value="true" color="red"></v-radio>
                    <v-radio label="no" value="false" color="red"></v-radio>
                  </v-radio-group>
                </v-col>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <div class="pl-16 mb-10">
                <v-btn
                  color="primary"
                  elevation="7"
                  large
                  @click="funcionColegioTecnico()"
                  >Siguiente</v-btn
                >
              </div>
            </v-card-actions>
          </v-card>
        </div>

        <div v-if="verCuantosAnos">
          <v-card elevation="11" outlined shaped>
            <v-card-title class="d-flex justify-left pl-16"
              >3)¿ De Cuantos años ?
            </v-card-title>
            <v-card-text class="pl-12">
              <v-container fluid v-if="colegioTecnico == 'true'">
                <v-col cols="12" sm="6" md="6">
                  <v-radio-group v-model="cuantosAnos">
                    <v-radio label="4 años" value="4" color="red"></v-radio>
                    <v-radio label="6 años" value="6" color="red"></v-radio>
                    <v-radio label="7 años" value="7" color="red"></v-radio>
                  </v-radio-group>
                </v-col>
              </v-container>

              <v-container fluid v-else>
                <v-col cols="12" sm="6" md="6">
                  <v-radio-group v-model="cuantosAnos">
                    <v-radio label="3 años" value="3" color="red"></v-radio>
                    <v-radio label="4 años" value="4" color="red"></v-radio>
                    <v-radio label="5 años" value="5" color="red"></v-radio>
                    <v-radio label="6 años" value="6" color="red"></v-radio>
                  </v-radio-group>
                </v-col>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <div class="pl-16 mb-10">
                <v-btn
                  color="primary"
                  elevation="7"
                  large
                  @click="funcionCuantosAnos()"
                  >Siguiente</v-btn
                >
              </div>
            </v-card-actions>
          </v-card>
        </div>

        <div v-if="verAc">
          <v-card elevation="11" outlined shaped>
            <v-card-title class="d-flex justify-left pl-16"
              >4)¿ Que año completo y aprobo todo ?
            </v-card-title>
            <v-card-text class="pl-12">
              <v-container fluid>
                <v-col cols="12" sm="6" md="6">
                  <v-radio-group v-model="ac">
                    <v-radio
                      v-for="(respuesta, index) in acRespuestas"
                      :key="index"
                      :label="respuesta.label"
                      :value="respuesta.value"
                      color="red"
                    >
                    </v-radio>
                  </v-radio-group>
                </v-col>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <div class="pl-16 mb-10">
                <v-btn color="primary" elevation="7" large @click="funcionAc()"
                  >Siguiente</v-btn
                >
              </div>
            </v-card-actions>
          </v-card>
        </div>

        <div v-if="verAdeudaMaterias">
          <v-card elevation="11" outlined shaped>
            <v-card-title class="d-flex justify-left pl-16"
              >5)¿ Adeuda mas de 2 Materias ?
            </v-card-title>
            <v-card-text class="pl-12">
              <v-container fluid>
                <v-col cols="12" sm="6" md="6">
                  <v-radio-group v-model="adeudaMaterias">
                    <v-radio label="si" value="true" color="red"></v-radio>
                    <v-radio label="no" value="false" color="red"></v-radio>
                  </v-radio-group>
                </v-col>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <div class="pl-16 mb-10">
                <v-btn
                  @click="funcionAdeudaMaterias()"
                  color="primary"
                  elevation="7"
                  large
                  >siguiente</v-btn
                >
              </div>
            </v-card-actions>
          </v-card>
        </div>

        <!-- si el alumno esta en 1er año -->

        <div v-if="verAprobastesMateriaPrimerAno">
          <v-card elevation="11" outlined shaped>
            <v-card-title class="d-flex justify-left pl-16"
              >6)¿ Aprobastes alguna materia del secundario ?
            </v-card-title>
            <v-card-text class="pl-12">
              <v-container fluid>
                <v-col cols="12" sm="6" md="6">
                  <v-radio-group v-model="aprobastesMateriaPrimerAno">
                    <v-radio label="si" value="true" color="red"></v-radio>
                    <v-radio label="no" value="false" color="red"></v-radio>
                  </v-radio-group>
                </v-col>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <div class="pl-16 mb-10">
                <v-btn
                  color="primary"
                  @click="functionAprobasteMateriaPrimerAno()"
                  elevation="7"
                  large
                  >siguiente</v-btn
                >
              </div>
            </v-card-actions>
          </v-card>
        </div>

        <div v-if="verMaterias">
          <v-card elevation="11" outlined shaped>
            <v-card-title class="d-flex justify-left pl-16"
              >7)¿ Indique cuales materias aprobo ?
            </v-card-title>
            <v-card-text class="pl-12">
              <v-container fluid>
                <v-col
                  cols="12"
                  sm="6"
                  md="6"
                  v-for="(materia, index) in materias"
                  :key="index"
                >
                  <v-checkbox
                    v-model="materiasSeleccionadas"
                    color="primary"
                    :value="materia.value"
                    hide-details
                  >
                    <template v-slot:label>
                      <div>
                        <strong>{{ materia.label }}</strong>
                      </div>
                    </template>
                  </v-checkbox>
                </v-col>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <div class="pl-16 mb-10">
                <v-btn
                  color="primary"
                  @click="functionFinalizar()"
                  elevation="7"
                  large
                  >Finalizar</v-btn
                >
              </div>
            </v-card-actions>
          </v-card>
        </div>

        <div v-if="verColegioPrimarioNuevaAnos">
          <v-card elevation="11" outlined shaped>
            <v-card-title class="d-flex justify-left pl-16"
              >8)¿ Tu colegio primario era de 9 años ?
            </v-card-title>
            <v-card-text class="pl-12">
              <v-container fluid>
                <v-col cols="12" sm="6" md="6">
                  <v-radio-group v-model="colegioPrimarioNuevaAnos">
                    <v-radio label="si" value="true" color="red"></v-radio>
                    <v-radio label="no" value="false" color="red"></v-radio>
                  </v-radio-group>
                </v-col>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <div class="pl-16 mb-10">
                <v-btn
                  color="primary"
                  @click="functionColegioPrimarioNuevaAnos()"
                  elevation="7"
                  large
                  >siguiente</v-btn
                >
              </div>
            </v-card-actions>
          </v-card>
        </div>

        <div v-if="verTerminastePrimario">
          <v-card elevation="11" outlined shaped>
            <v-card-title class="d-flex justify-left pl-16"
              >8)¿ Terminaste ?
            </v-card-title>
            <v-card-text class="pl-12">
              <v-container fluid>
                <v-col cols="12" sm="6" md="6">
                  <v-radio-group v-model="terminastePrimario">
                    <v-radio label="si" value="true" color="red"></v-radio>
                    <v-radio label="no" value="false" color="red"></v-radio>
                  </v-radio-group>
                </v-col>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <div class="pl-16 mb-10">
                <v-btn
                  color="primary"
                  @click="functionTerminastePrimario()"
                  elevation="7"
                  large
                  >siguiente</v-btn
                >
              </div>
            </v-card-actions>
          </v-card>
        </div>
      </v-col>
    </CardIeaAppMain>
  </div>
</template>
<script>
import CardIeaAppMain from "../../components/CardIeaAppMain";
export default {
  name: "bceEquivalencia",
  components: {
    CardIeaAppMain,
  },
  data() {
    return {
      verRealizoSecundario: true,
      realizoSecundario: null,
      ac: 1,
      verAc: false,
      colegioTecnico: null,
      verColegioTecnico: false,
      verCuantosAnos: false,
      cuantosAnos: null,
      acRespuestas: [],
      verAdeudaMaterias: false,
      adeudaMaterias: null,
      verAprobastesMateriaPrimerAno: false,
      aprobastesMateriaPrimerAno: null,
      materias: [],
      verMaterias: false,
      vercolegioPrimario: false,
      colegioPrimario: null,
      colegioPrimarioNuevaAnos: null,
      verColegioPrimarioNuevaAnos: false,
      verTerminastePrimario: false,
      terminastePrimario: null,
      materiasSeleccionadas: [],
      materiasPreaprobadas: [],
      verAdeudasMateriasPrimerAno: false,
      adeudasMateriasPrimerAno: null,
    };
  },
  methods: {
    funcionRealizoSecundario() {
      if (this.realizoSecundario == "true") {
        this.verRealizoSecundario = false;
        this.verColegioTecnico = true;
      } else {
        this.ac = 1;
      }
    },
    funcionColegioTecnico() {
      this.verColegioTecnico = false;
      this.verCuantosAnos = true;
    },
    funcionCuantosAnos() {
      if (this.colegioTecnico == "true") {
        if (this.cuantosAnos == 4) {
          this.acRespuestas = [
            { label: "ninguno", value: 1 },
            { label: "2 ó 3", value: 2 },
            { label: "4 ó 5 ó 6", value: 3 },
          ];
        } else if (this.cuantosAnos == 6) {
          this.acRespuestas = [
            { label: "ninguno", value: 1 },
            { label: "1 ó 2", value: 2 },
            { label: "3,4,5 y 6", value: 3 },
          ];
        } else if (this.cuantosAnos == 7) {
          this.acRespuestas = [
            { label: "ninguno ó 1", value: 1 },
            { label: "2 ó 3", value: 2 },
            { label: "4,5,6 y 7", value: 3 },
          ];
        }
      } else {
        if (this.cuantosAnos == 3) {
          this.acRespuestas = [
            { label: "ninguno", value: 1 },
            { label: "1", value: 2 },
            { label: "2 ó 3", value: 3 },
          ];
        } else if (this.cuantosAnos == 4) {
          this.acRespuestas = [
            { label: "ninguno", value: 1 },
            { label: "1", value: 2 },
            { label: "2,3 y 4", value: 3 },
          ];
        } else if (this.cuantosAnos == 5) {
          this.acRespuestas = [
            { label: "ninguno", value: 1 },
            { label: "1 ó 2", value: 2 },
            { label: "3 ó 4 ó 5", value: 3 },
          ];
        } else if (this.cuantosAnos == 6) {
          this.acRespuestas = [
            { label: "ninguno ó 1", value: 1 },
            { label: "2 ó 3", value: 2 },
            { label: "4 ó 5 ó 6", value: 3 },
          ];
        }
      }

      this.verCuantosAnos = false;
      this.verAc = true;
    },
    funcionAc() {
      if (this.ac > 1) {
        this.verAc = false;
        this.verAdeudaMaterias = true;
      } else {
        if (this.ac == 1) {
          this.verAc = false;
          this.verAprobastesMateriaPrimerAno = true;
        }
      }
    },
    funcionAdeudaMaterias() {
      this.verAdeudaMaterias = false;
      if (this.adeudaMaterias == "true" && this.ac > 1) {
        this.ac = this.ac - 1;
      }

      if (this.ac == 1) {
        this.verAprobastesMateriaPrimerAno = true;
      } else if (this.ac == 2) {
        this.functionAprobastesMaterias2ano();
      } else if (this.ac == 3) {
        this.functionAprobastesMaterias3ano();
      }
    },
    functionAprobasteMateriaPrimerAno() {
      this.verAprobastesMateriaPrimerAno = false;

      if (this.aprobastesMateriaPrimerAno == "true") {
        this.materias = [
          { label: "LenguaI", value: "LenguaI" },
          { label: "InglesI", value: "InglesI" },
          { label: "MatemáticasI", value: "MatemáticasI" },
          { label: "Informatica", value: "Informatica" },
          { label: "Historia", value: "Historia" },
          { label: "Civica", value: "Civica" },
          { label: "Biologia", value: "Biologia" },
        ];

        this.verMaterias = true;
      } else {
        this.verColegioPrimarioNuevaAnos = true;
      }
    },
    functionColegioPrimarioNuevaAnos() {
      if (this.colegioPrimarioNuevaAnos == "true") {
        this.verColegioPrimarioNuevaAnos = false;
        this.verTerminastePrimario = true;
      }else{
        this.functionFinalizar();
      }
    },
    functionTerminastePrimario() {
      if (this.terminastePrimario == "true") {
        this.materiasSeleccionadas = [
           "LenguaI" ,
           "MatemáticasI" ,
        ];
      }

      this.functionFinalizar();
    },
    functionAprobastesMaterias2ano() {
      this.materias = [
        { label: "Contabilidad", value: "Contabilidad" },
        {
          label: "Administracion de Empresas",
          value: "Administracion de Empresas",
        },
        { label: "Quimica", value: "Quimica" },
        { label: "Fisica", value: "Fisica" },
        { label: "Derecho", value: "Derecho" },
        { label: "Marqueting", value: "Marqueting" },
        { label: "Economia", value: "Economia" },
        { label: "Informatica", value: "Informatica" },
        { label: "Historia", value: "Historia" },
        { label: "Civica", value: "Civica" },
        { label: "Biologia", value: "Biologia" },
      ];

      this.verMaterias = true;
    },
    functionAprobastesMaterias3ano() {
      this.materias = [
        { label: "Contabilidad", value: "Contabilidad" },
        {
          label: "Administracion de Empresas",
          value: "Administracion de Empresas",
        },
        { label: "Quimica", value: "Quimica" },
        { label: "Fisica", value: "Fisica" },
        { label: "Derecho", value: "Derecho" },
        { label: "Marqueting", value: "Marqueting" },
        { label: "Problematica Social", value: "Problematica Social" },
        { label: "Economia", value: "Economia" },
        { label: "Informatica", value: "Informatica" },
      ];

      this.verMaterias = true;
    },
    functionFinalizar() {
      let data = [
        {
          realizoSecundario: this.realizoSecundario,
          anoCursar: this.ac,
          colegioTecnico: this.colegioTecnico,
          cuantosAnosColegioTecnico: this.cuantosAnos,
          adeudaMaterias: this.adeudaMaterias,
          aprobastesMateriaPrimerAno: this.aprobastesMateriaPrimerAno,
          materiasAprobadas: this.materiasSeleccionadas,
          colegioPrimarioNuevaAnos: this.colegioPrimarioNuevaAnos,
          terminastePrimario: this.terminastePrimario,
        },
      ];

      this.$API
        .post({
          url: "guardar-test-equivalencia",
          data: data,
        })
        .then(() => {
          this.$router.push({
            name: "Home",
            
          });
        })
        .catch(() => {
          this.$router.push({
            name: "Home",
          });
        });
    },
  },
};
</script>